import { render, staticRenderFns } from "./Concepts.vue?vue&type=template&id=5ba428c8&scoped=true&"
import script from "./Concepts.vue?vue&type=script&lang=js&"
export * from "./Concepts.vue?vue&type=script&lang=js&"
import style0 from "./Concepts.vue?vue&type=style&index=0&id=5ba428c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba428c8",
  null
  
)

export default component.exports